<template>
    <v-container fluid light>
        <v-row align="center" justify="center">
            <v-col>
                <v-data-table :headers="filteredHeaders"
                              fixed-header
                              fixed-footer
                              height="600px"
                              :items="items"
                              :options.sync="options"
                              :loading="loading"
                              :footer-props="footerProps"
                              class="elevation-1"
                              show-expand
                              :expanded.sync="expanded"
                              :single-expand=true
                              item-key="id"
                              dense>
                    <template v-slot:[`item.startDate`]="{ item }">
                        {{ item.startDate | formatDate }}
                    </template>
                    <template v-slot:[`item.endDate`]="{ item }">
                        {{ item.endDate | formatDate }}
                    </template>
                    <template v-slot:[`item.isActive`]="{ item }">
                        <v-icon
                            v-if="item.isActive"
                            color="green"
                            class="my-2"
                        >
                            mdi-checkbox-marked-circle
                        </v-icon>
                    </template>
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-toolbar-title>Trip Schedules</v-toolbar-title>
                            <v-divider class="mx-4"
                                       inset
                                       vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary"
                                           v-if="hasAccess('SCHEDULE')"
                                           dark
                                           class="mb-2"
                                           v-bind="attrs"
                                           v-on="on">New Trip</v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.name" label="Trip Name *" required></v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-select v-model="editedItem.scheduleTypeId"
                                                              :items="scheduleTypes"
                                                              label="Schedule Type *"
                                                              item-text="id"
                                                              :item-value="editedItem.scheduleTypeId"
                                                              :loading="loading"
                                                              required></v-select>
                                                </v-col>
                                               
                                                <v-col cols="12">
                                                    <v-menu ref="menu1"
                                                            v-model="menu1"
                                                            :close-on-content-click="false"
                                                            transition="scale-transition"
                                                            offset-y
                                                            max-width="290px"
                                                            min-width="290px">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-model="editedItem.formattedStartDate"
                                                                          label="Start Date"
                                                                          hint="YYYY-MM-DD format"
                                                                          persistent-hint
                                                                          prepend-icon="mdi-calendar"
                                                                          v-bind="attrs"
                                                                          @blur="editedItem.formattedStartDate = parseDate(editedItem.startDate)"
                                                                          v-on="on"></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="editedItem.startDate"
                                                                       no-title @input="menu1 = false"
                                                                       @change="editedItem.formattedStartDate = parseDate(editedItem.startDate)"></v-date-picker>
                                                    </v-menu>

                                                </v-col>
                                                <v-col cols="12">

                                                    <v-menu ref="menu2"
                                                            v-model="menu2"
                                                            :close-on-content-click="false"
                                                            transition="scale-transition"
                                                            offset-y
                                                            max-width="290px"
                                                            min-width="290px">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-model="editedItem.formattedEndDate"
                                                                          label="End Date"
                                                                          hint="YYYY-MM-DD format"
                                                                          persistent-hint
                                                                          prepend-icon="mdi-calendar"
                                                                          v-bind="attrs"
                                                                          @blur="editedItem.formattedEndDate = parseDate(editedItem.endDate)"
                                                                          v-on="on"></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="editedItem.endDate"
                                                                       no-title @input="menu2 = false"
                                                                       @change="editedItem.formattedEndDate = parseDate(editedItem.endDate)"></v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
                                        <v-btn color="blue darken-1" text @click="save()">Save</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon small
                                class="mr-2"
                                @click="editItem(item)">
                            mdi-pencil
                        </v-icon>
                        <v-icon small
                                @click="deleteItem(item)">
                            mdi-delete
                        </v-icon>
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                        <td v-bind:colspan="headers.length">
                            <TripDetails :item="item" :key="item.id" @activeOrderChanged="onChangeChild" />
                        </td>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import TripDetails from './TripDetails.vue';
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import appsettings from '../../appsettings.js';
    import moment from 'moment';
    import axios from "axios";
    export default {
        data() {
            return {
                locationId:"",
                items: [],
                expanded: [],
                loading: true,
                dialog: false,
                menu1: false,
                menu2: false,
                scheduleTypes: [],
                editedIndex: -1,
                editedItem: {
                    id: 0,
                    name: "",
                    locationId: "",
                    formattedStartDate: "",
                    startDate: "",
                    endDate: "",
                    formattedEndDate: "",
                },
                defaultItem: {
                    id: 0,
                    name: "",
                    locationId: "",
                    formattedStartDate: "",
                    startDate: "",
                    endDate: "",
                    formattedEndDate: "",
                },
                options: {},
                rules: {
                    
                },
                footerProps: {
                    'items-per-page-options': appsettings.config.pages
                },
                headers: [
                    {
                        text: 'Schedule',
                        align: 'start',
                        value: 'name',
                        width: '40%',
                        sortable: false
                    },
                    {
                        text: 'Type',
                        value: 'scheduleTypeId',
                        width: '10%',
                        sortable: false
                    },
                    {
                        text: 'Active',
                        value: 'isActive',
                        width: '10%',
                        sortable: false
                    },
                    {
                        text: 'Start',
                        value: 'startDate',
                        width: '10%',
                        sortable: false
                    },
                    {
                        text: 'End',
                        value: 'endDate',
                        width: '10%',
                        sortable: false
                    },
                    { text: 'Actions', value: 'actions', sortable: false },
                ],
            }
        },
        filters: {

            formatDate: function (value) {
                return moment(String(value)).format('YYYY-MM-DD');
            },
        },
        components: {
            TripDetails
        },
        computed: {

            formTitle() {
                return this.editedIndex === -1 ? 'New Trip' : 'Edit Trip'
            },
            
            filteredHeaders() {
                return this.headers;
            },
            ...mapGetters(['getVrsUser', 'hasAccess']),
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
        },
        async mounted() {
           
            this.locationId = this.$route.params.locationId;

            this.options.itemsPerPage = this.getVrsUser.pageSize ?? appsettings.default.pageSize;

            this.scheduleTypes = await this.getScheduleTypesFromApi();

            this.items = await this.getDataFromApi();

        },
        methods: {
            ...mapActions(['sendMessage', 'refreshActiveTrip']),
            async getDataFromApi() {

                this.loading = true;

                const { sortBy, sortDesc, page, itemsPerPage } = this.options;

                let response = await axios.get(`/api/schedule/location/${this.locationId}?PageNumber=${page}&PageSize=${itemsPerPage}`);

                this.loading = false;

                return response.data;

            },

            async getScheduleTypesFromApi() {

              this.loading = true;

              let response = await axios.get(`/api/Lookup/scheduletypes`);
              let data = response.data;
              data.sort((a, b) => a.id.localeCompare(b.id));

              this.loading = false;

              return data;

            },
            async saveData(tripData) {
           
              this.loading = true;

              tripData.errorMessage = '';
              tripData.hasError = false;
              let data = null;
              
              try {
                if (tripData.id == 0) {
                  tripData.locationId = this.locationId;
                  let response = await axios.post(`/api/schedule`, tripData);
                  data = response.data;
                } else {
                  let response = await axios.put(`/api/schedule`, tripData);
                  data = response.data;
                }
              }
              catch(error) {
                tripData.errorMessage = 'An unknown network has occurred.';
                tripData.hasError = true;

                return tripData;
              }

              await this.refreshActiveTrip(true);

              this.loading = false;
              return data;
          
            },

            editItem(item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.editedItem.formattedStartDate = this.parseDate(this.editedItem.startDate);
                this.editedItem.formattedEndDate = this.parseDate(this.editedItem.endDate); 
                this.dialog = true
            },

            async deleteItem(item) {
                const index = this.items.indexOf(item)

                if (!confirm('Are you sure you want to delete this item?'))
                { return; }

                this.loading = true;

                let route = `/api/schedule`;
                let method = 'DELETE';
                let onResolve = null;
              
                try {
                  let response = await axios.delete(`/api/schedule`,item);
                  this.items.splice(index, 1);
                  this.loading = false;
                  return response.data;
                }
                catch(error) {
                  item.errorMessage = 'An unknown network has occurred.';
                  item.hasError = true;
                  this.loading = false;
                  return item;
                }

            },

            close() {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },
            setActiveTrip(tripData) {

                this.items.forEach((item) => {
                    if (item.id != tripData.id) {
                        item.isActive = false;
                    }
                });

                this.saveData(tripData)
                    .then(data => {
                        tripData = data;
                        this.refreshActiveTrip(true);
                    });

                
            },
            save(value) {

                this.saveData(this.editedItem)
                    .then(data => {
                        this.editedItem = data;

                        if (this.editedIndex > -1) {
                            Object.assign(this.items[this.editedIndex], this.editedItem);
                        } else {
                            this.items.push(this.editedItem)
                        }
                        if (this.editedItem.isActive) {
                            this.items.forEach((item) => {
                                if (item.id != this.editedItem.id) {
                                    item.isActive = false;
                                }
                            });
                        }
                        this.close()
                    });

     

            },
            formatDate(date) {
                if (!date) return null

                return moment(String(date)).format('YYYY-MM-DD');
            },

            parseDate(date) {
                if (!date) return null

                return moment(String(date)).format('YYYY-MM-DD');
            },

            async onChangeChild() {
                this.items = await this.getDataFromApi();
            }
        }
    }
</script>